import { render } from "./PinLink.vue?vue&type=template&id=6105dca5&scoped=true"
import script from "./PinLink.vue?vue&type=script&lang=js"
export * from "./PinLink.vue?vue&type=script&lang=js"

import "./PinLink.vue?vue&type=style&index=0&id=6105dca5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mybyu/mybyu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6105dca5"]])

export default __exports__